export async function fetchWorkspaceOptions(requestJson, {
  includeArchived = false,
  q,
} = {}) {
  const params = new URLSearchParams()
  if (includeArchived) {
    params.set('includeArchived', 'true')
  }
  if (q?.trim()) {
    params.set('q', q.trim())
  }

  const suffix = params.toString() ? `?${params}` : ''
  const data = await requestJson(`/workspaces/options${suffix}`)
  const items = Array.isArray(data?.items) ? data.items : []
  return items.map((item) => ({
    workspaceId: item.workspaceId ?? item.id,
    ...(item.name ? { name: item.name } : {}),
    ...(item.status ? { status: item.status } : {}),
  }))
}
